import { useSelector } from 'react-redux';
import { RootState } from 'src/services';
import Template1 from './Template1';
import Template3 from './Template3';

type TemplatesTypes = {
  templateId: number;
  mobileDevice: boolean;
};

export default function Templates(props: TemplatesTypes) {
  const { templateId, mobileDevice } = props;
  const template = useSelector<RootState, []>((state) => state.template.templateData);
  let Component;
  switch (templateId) {
    case 1:
      Component = Template1;
      break;
    case 3:
      Component = Template3;
      break;
    default:
      Component = () => (
        <div className="d-flex flex-column align-items-center justify-content-center fs-1 fw-bold text-muted" style={{ height: '400px' }}>
          <span>Template Bulunamadı</span>
        </div>
      );
  }
  if (!template)
    return (
      <div className="d-flex flex-column align-items-center justify-content-center fs-4 fw-bold text-muted" style={{ height: '400px' }}>
        <span>Şablon oluşturulurken bir sorun oluştu!</span>
      </div>
    );
  return <Component mobileDevice={mobileDevice} templateData={template} templateId={templateId} />;
}
